import React from 'react';
import { func, instanceOf, shape, bool } from 'prop-types';
import { useSelector } from 'react-redux';

import BackButton from '../../../shared/BackButton';
import CommonStudySelector from '../../../../common/CommonStudySelector';
import { CROSSTAB_FEATUREID } from '../../../../../constants';
import DefinationView from './DefinationView';
import { DATA_ENABLEMENT } from '../../../shared/DEConstants'

const Definations = ({
  setView,
  studyDefinition,
  setActiveStudyTarget,
  deStudies,
  getStudyTargets,
  setSelectedDefinition,
  isLatestStudy,
  handleChangeWeightType,
}) => {
  const isEditTargetDefinition = useSelector(state => state.deImportDefiniton.isEditTargetDefinition);
  const setSelectedStudy = study => {
    getStudyTargets(study);
  };

  const _handleChangeWeightType = weightType => {
    handleChangeWeightType(weightType)
  }
  const weightTypeObject = deStudies.activeStudy.cw.find(
    weightType => weightType.wt === deStudies.activeStudy.wt);

  return (
    <div className="de--def__root de--flex-col de--flex-col-1">
      <div className="de--def__top">
        <div className="de--def__header">
          <BackButton onClick={() => setView('Dashboard')} />
        </div>
        <div className="de--def__studyselector">
          <div>
            <CommonStudySelector
              menuName={DATA_ENABLEMENT}
              studies={deStudies.data}
              featureID={CROSSTAB_FEATUREID}
              defaultStudy={deStudies.activeStudy}
              setMethod={setSelectedStudy}
              showWeightType
              handleChangeWeightType={_handleChangeWeightType}
              selectedWeightType={{
                wt: weightTypeObject.wt,
                wn: weightTypeObject.wn,
                dv: deStudies.activeStudy.dv,
              }}
            />
          </div>
        </div>
      </div>
      <div className="de--def__body de--flex-col-1 de-o-hidden">
        <DefinationView
          studyDefinition={studyDefinition}
          setActiveStudyTarget={setActiveStudyTarget}
          setSelectedDefinition={setSelectedDefinition}
          isLatestStudy={isLatestStudy}
        />
      </div>
      {isEditTargetDefinition && <div className = "de--import--left-overlay" />}
    </div>
  );
};

Definations.propTypes = {
  setView: func,
  setActiveStudyTarget: func,
  setSelectedDefinition: func,
  studyDefinition: shape({
    activeStudy: instanceOf(Object),
    studyTargets: {
      loading: bool,
      error: bool,
      data: instanceOf(Array),
    },
    available: instanceOf(Object),
    selected: instanceOf(Array),
    imports: instanceOf(Array),
  }),
  getStudyTargets: func,
  handleChangeWeightType: func,
  isLatestStudy: bool,
  deStudies: shape({
    defaultStudy: instanceOf(Object),
    activeStudy: instanceOf(Object),
    loading: bool,
    error: bool,
    data: instanceOf(Array),
  }),
};

export default Definations;
